import ListItem from "@/components/ListItem/ListItem";
import { toFormat } from "@/lib/dateHelpers";
import { formatLocationText } from "./utils";

export interface EventHit {
  objectID: string;
  id: string;
  title: string;
  slug?: string;
  startsAt: string;
  endsAt: string;
  city?: string;
  state?: string;
  facilityName?: string;
  eventCode?: string | null;
  object_type?: string;
}

export const formatEventDateRange = (startsAt: string, endsAt: string): string => {
  const start = toFormat(startsAt, "LLL dd, yyyy");
  const end = toFormat(endsAt, "LLL dd, yyyy");
  if (!start || !end) return "";
  if (start === end) return start;
  return `${start} – ${end}`;
};

export const getEventSupportingText = (hit: EventHit): string | undefined => {
  const location = [hit.facilityName, formatLocationText(hit.city, hit.state)].filter(Boolean).join("\n");
  const dateRange = formatEventDateRange(hit.startsAt, hit.endsAt);
  return (
    [location, dateRange, hit.eventCode ? `Event ID: ${hit.eventCode}` : undefined].filter(Boolean).join("\n") ||
    undefined
  );
};

export const renderEventHit = (hit: EventHit, select: (hit: EventHit) => void) => {
  return (
    <button
      key={hit.objectID || hit.id}
      type="button"
      className="cursor-pointer w-full text-left"
      onClick={() => select(hit)}
    >
      <ListItem compact useAvatar iconName="today" headline={hit.title} supportingText={getEventSupportingText(hit)} />
    </button>
  );
};

export const getEventDisplayName = (hit: EventHit): string => {
  return hit.title || "Unknown Event";
};
